import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ToastWrapper } from "./styled"

const Toast = ({ children }) => {
    return (
        <>
            <div>{children}</div>
            <ToastWrapper>
                <ToastContainer />
            </ToastWrapper>
        </>
    )
}

export default Toast